import { CashDiscountType } from '../enums';

export class CashDiscountTypeLookup {

    static getLookup(): any[] {
        return [
            { label: 'Net', value: CashDiscountType.Net },
            { label: 'Gross', value: CashDiscountType.Gross },
        ];
    }
}